import React, { Component } from 'react';
import { Loader } from '../../utils/common';
import { Row, Col, Modal, Button, ModalHeader, ModalBody, ModalFooter, FormGroup, Label, Input, Form , Alert } from "reactstrap";  
import SimpleReactValidator from 'simple-react-validator';



class EditAppSetting extends Component {
  constructor(props) {
    super(props);
    this.validator = new SimpleReactValidator();
    this.state = {
      title : (this.props.formData.title) ? this.props.formData.title : "",
      value : (this.props.formData.value) ? this.props.formData.value : "",
      settingsId : (this.props.formData._id) ? this.props.formData._id : "",
      showErrorMsg : false
    }
  }

  componentDidMount() {
  }

  componentWillReceiveProps(nextProps) {
   // let self = this;
    Loader(nextProps.requestProcess);
  }


  

  handleChange(event) {
    let target = event.target;
    let name = target.name;
    let value;
    value = target.value;
    this.setState({[name]: value});
  }

  handleSubmit(e) {
    if( this.validator.allValid()){
      this.setState({showErrorMsg : false});
      let settingsObj = {
        title : this.state.title,
        value : this.state.value,
        settingId : this.state.settingsId
      }  
      this.props.updateSetting(e, settingsObj);
    }else{
      this.validator.showMessages();
      this.forceUpdate();
    }
    e.preventDefault();
  }

  



  render() {
   // let self = this;
    let { openEditAppSettingModal, closeModal, updateSettingPopupError } = this.props;
    

    return (
      <Modal isOpen={openEditAppSettingModal}>
          <ModalHeader toggle={()=>{closeModal(false)}}>Update setting</ModalHeader>
          <Form onSubmit={(event) => {this.handleSubmit(event)}}>  
            <ModalBody>
              <Row>
                <Col xs="12">
                    <FormGroup>
                      <Label htmlFor="title">Title</Label>
                      <Input type="text" id="title" placeholder="Title" name="title" value={this.state.title} onChange={(event)=>{this.handleChange(event)}} />                                              
                      <div className="validation-error">{ this.validator.message('title', this.state.title, 'required') }</div>   
                    </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col xs="12">
                    <FormGroup>
                      <Label htmlFor="title">Value</Label>
                      <Input type="text" id="value" placeholder="Value" name="value" value={this.state.value} onChange={(event)=>{this.handleChange(event)}} />                                              
                      <div className="validation-error">{ this.validator.message('value', this.state.value, 'required') }</div>   
                    </FormGroup>
                </Col>
              </Row>
              {(updateSettingPopupError) ? <Alert color="danger">{updateSettingPopupError}</Alert> : null}
            </ModalBody>
            <ModalFooter className="justify-content-left">
              <Button type="submit" size="sm" color="primary">Update</Button>{' '}
              <Button type="reset" size="sm" color="danger"  onClick={() => { closeModal() }}>Cancel</Button>
            </ModalFooter>
          </Form>
        </Modal>
      
    );
  }
}

export default EditAppSetting;
